// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Header.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-m {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 20px);
}
.toggle-ind{
  display: flex;
  flex-direction: row;

}
.ind-tog{
  color: white;
  padding-left: 20px;
  font-size: medium;
}
.left-class-m {
  margin-left: 350px;
  margin-bottom: 5px;
}

.left-class-m.collapsed-left-panel {
  margin-left: 3px;
}

.industry-class-m {
  width: 13%;
  margin-left: 15px;
  margin-top: 5px;
}

.sidebar-toggle {
  width: 20px;
  margin-bottom: 65px;
  margin-left: 3px;
}

/* .industry-nav{
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  display: flex;
  color: white;
  padding-right: 10px;
} */

.primary {
  width: 100%;
  height: 7%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  display: flex;
  /* background-position: center; */
}

.accentureHeader {
  width: 6%;
  margin-left: 10px;
  margin-bottom: 7px;
}

.genaiHeader {
  color: #FFFFFF;
  font-size: 18px;
  font-family: Graphik;
  font-weight: 450;
  margin: 5px 15px;
  border-left: 1px solid #FFFFFF;
  padding: 0px 15px;
  width: 20%;
}

.icon-Header {
  width: 25px;
  height: 20px;
  margin-bottom: 2px;
}

.icon-Header-notification{
  width: 23px;
  height: 17px;
  margin-bottom: 4px;
  margin-left: 1px;
}
.icon-Header-logout{
  width: 19px;
  height: 16px;
  margin-bottom: 4px;
  margin-left: 5px;
}
.icon-Header-circle {
  background-color: #FFFFFF;
  border-radius: 50%;
  border: none;
  height: 25px;
  width: 25px;
  margin-right: 10px;
}

/* .username-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px; 
  -webkit-text-overflow: ellipsis;
} */
.header-toast {
  color: black;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 355;
}

.header-icon {
  display: flex;
  transform: translate(81%, 20%);
  top: 10%;
  left: 90%;
}

.header-dropdown-icon {
  width: 15px;
  margin:2px;
}
.user-header-box{
  background-color: #FFFFFF;
  border-radius: 30px;
  border: none;
  height: fit-content;
  /* width: fit-content; */
  /* margin-right: 10px; */
  padding: 2px 5px;
  display: flex;
  font-size: 12px;
  font-weight: 430;
  font-family: Graphik;
}
.indutry-m {
  color: #ffffff;
  font-size: 20px;
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  font-weight: 10px;

}

.industry-container-m {
  display: none;
  position: absolute;
  background-color: #ffffff;
  border: 1px solid #ccc;
  padding: 10px;
}

.selection:hover+.industry-container-m {
  display: block;
}

.selection-m {
  color: #738395;
  padding-bottom: 5px;
  margin-bottom: 10px;
  border-left: none;
  border-right: none;
  margin-bottom: 20px;
  width: 80%;
  font-size: 15px;
  margin-top: 80px;
  font-weight: 7px;
}

.icon-industry {
  margin-right: 10px;
  width: 50%;
}

.icon {
  margin-right: 30px;

  margin-top: 10px;

}

.icon1 {
  margin-right: 30px;

  margin-top: 10px;

}

.icon-container-m:hover {
  border-bottom: 5px solid #AD8BFF;
  border-left: 2px solid #738395;
  border-right: 2px solid #738395;
  border-top: 2px solid #738395;
  color: #A404ED;
  /* Add other hover styles as needed */
}

.icon-container-m:active {

  border-bottom: 5px solid #AD8BFF;
  border-left: 2px solid #738395;
  border-right: 2px solid #738395;
  border-top: 2px solid #738395;
  color: #A404ED;
  /* Add other active (clicked) styles as needed */
}

.icon-container1-m:hover {

  border-bottom: 5px solid #AD8BFF;
  border-left: 2px solid #738395;
  border-right: 2px solid #738395;
  border-top: 2px solid #738395;
  color: #A404ED;
  /* Add other hover styles as needed */
}

.icon-container1-m:active {

  border-bottom: 5px solid #AD8BFF;
  border-left: 2px solid #738395;
  border-right: 2px solid #738395;
  border-top: 2px solid #738395;
  color: #A404ED;
  /* Add other active (clicked) styles as needed */
}

.col-sm-8 icons2-m {
  margin-top: 50px;
}


/* Decrease the icon size when collapsed */
.collapsed-sidebar .side-img {
  width: 25px !important;
}

.collapsed-sidebar .side-img1 {
  width: 25px !important;
  padding-left: 5px;
  padding-right: 5px;
}

.expanded-sidebar .side-img2{
  width: 10px !important;
  margin-right: 20px;
  margin-left: 5px;
}
.collapsed-sidebar .side-img2{
  width: 25px !important;
  padding-left: 5px;
  padding-right: 5px;
}


.icon-container-m {
  color: #fff;
  text-decoration: none;
  margin-top: 20px;
  background-color: rgba(59, 65, 102, 1);
  /* Black with 10% opacity */
  height: 210px;
  text-align: center;
  padding-top: 10px;
  border-radius: 15px;
  width: 20%;
  margin-bottom: 10px;
  margin-left: 30px;
}

.icon-container-m2 {
  color: #fff;
  text-decoration: none;
  margin-top: 20px;
  background-color: rgba(59, 65, 102, 1);
  /* Black with 10% opacity */
  height: 210px;
  text-align: center;
  padding-top: 10px;
  border-radius: 15px;
  width: 21%;
  margin-bottom: 10px;
  margin-left: 30px;
}

.mark {
  background-color: #fff;
}

.watermark-m {
  padding-top: 50px;
}

.landing-text {
  font-size: 15px;
  font-family: Graphik;
  font-weight: 400;
  color: #fff;
  margin-top: 5px;
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
}

.landing-text-drill {
  font-size: 15px;
  font-family: Graphik;
  font-weight: 400;
  color: #fff;
  margin-top: 5px;
  text-wrap: wrap;
  width: 180px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: left;
}

.icon-container1-m {
  margin-top: 10px;
  color: #fff;
  text-decoration: none;
  background-color: rgba(59, 65, 102, 1);
  /* Black with 10% opacity */
  height: 213px;
  padding-top: 10px;
  border-radius: 15px;
  text-align: center;
  width: 20%;
  margin-bottom: 20px;
  margin-left: 30px;
}

.utility-header-m {
  font-size: 20px;
  font-weight: 10px;
  color: #000;
  margin-left: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}

/* Add this to your App.css or a separate CSS file */
.left-panel-m.collapsed-left-panel {
  /* Define your new styles here */
  /* For example: */
  width: 70px;
  transition: width 0.3s ease-in-out;
}

/* You can adjust the properties as needed */

.energy-m {
  display: flex;
  flex-direction: column;

}

.sub-H {
  display: flex;
  flex-direction: row;
}

.head {
  color: #738395;
  padding-left: 30px;
  padding-top: 20px;
  padding-bottom: 15px;
  font-size: 15px;
}

.head1 {
  color: #fff;
  margin-left: 30px;
  padding-top: 20px;
  padding-bottom: 15px;
  border-bottom: 3px solid #AD8BFF;
  font-size: 15px;
}

.icons-m {
  display: flex;
  flex-direction: row;
}

.left-panel-m {

  align-items: start;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  /* White with 10% opacity */

  display: flex;
  flex-direction: column;
  padding-top: 80px;
  padding-left: 20px;
  height: calc(100vh - 20px);
  width: 190px;
}

.collapsed-sidebar.left-panel-m {
  widows: 5%;
}

.utility-m {
  color: red;
  font-size: 20px;
}

.middle-panel-m {
  display: flex;
  flex-direction: row;
  /* height: 70px; */
}

.logo-header-m {

  display: flex;
  flex-direction: row;
  align-items: center;
}

.Heading-m {
  color: #FFFFFF;
  text-align: left;
  font-size: 20px;
}

.admin-img-m {
  width: 90%;
}

.industry-links {
  padding: 10px 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  max-height: 500px;
  /* A default value when not collapsed */
}

.industry-links.collapsed {
  max-height: 0;
}

.side-img {
  margin-right: 20px;
  width: 15%;
}

.admin-text-m {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
  color: #982588;
}

.no-underline {
  text-decoration: none;
}

.selected-m {
  color: #AD8BFF;
  padding-bottom: 5px;
  background-color: rgba(59, 65, 102, 1);
  padding-right: 50px;
  margin-bottom: 40px;
  width: 90%;
  font-size: 15px;
  font-weight: 7px;
  border-left: 3px solid #AD8BFF;
}

.collapsed-sidebar.selected-m {
  padding-right: 5px;
}

.collapse-img-m {
  justify-content: end;
  padding-right: 10px;
  align-items: center;
  align-self: flex-end;
}

.home-image-m {
  margin-bottom: 5px;
  margin-top: 5px;
  width: 15%;
  margin-right: 10px;
}

.Admin-m {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding-right: 10px;
  align-items: center;
  margin-left: 1200px;
  align-self: flex-end;
}


.second-container-m {



  margin-top: 20px;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  border-color: #8392B6;
  margin-left: 30px;
  min-height: 540px;
  border: 3px;
  padding: 20px;
  margin-right: 15px;
  text-align: left;
  background-color: #25304C;

}

.left-section-m {
  display: flex;
  padding-right: 20px;
  border-right: 1px solid #8392B6;
  flex-direction: column;
}

.select-dropdown-m {
  color: #8392B6;
  display: flex;
  flex-direction: row;
  font-size: 10px;
  padding-top: 20px;
}

.button-m {
  color: #4286F5;
  font-size: 10px;
  width: 40%;
  border-radius: 10px;
  margin-left: 75px;
  justify-content: center;
  box-shadow: 20px #122B45;
  margin-top: 30px;
  background-color: #FFFFFF;
  height: 30px;
}

.loading-m {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: black;
  margin-top: 10px;
}


.loading::after-m {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid white;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.assistant-heading-m {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-left: 5px;
  color: white;
  text-align: center;

}

.sales {
  background-color: red;
}

.panels-m {
  display: flex;
  background-color: rgba(32, 35, 66, 1);
  flex-direction: row;
  min-height: calc(100vh - 20px);
}

.right-panel-m {

  position: relative;

  background-color: #142137;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(0deg, #002644, #002644),
    linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2));
  border: 1px solid #335169;

}




.title-m {

  font-family: 'Arial', sans-serif;

  font-size: 28px;

  color: #333;

  margin-bottom: 20px;

}




.dropdown-container-m {

  margin-bottom: 20px;

}


.dropdown-label-m {

  color: #BEC1D6;
  font-size: 12px;
}


.logo-class-m {

  width: 80%;
  margin-left: 20px;
}

.selected-files-container-m {
  margin-top: 10px;
  min-height: 50px;
}

/* CSS for selected files */
.selected-file-m {
  margin-top: 5px;
  padding: 5px;
  color: #FFFFFF;
  font-size: 10px;
}

.dropdown-select-m {

  background: #FFFFFF;
  appearance: none;
  border: 2px dashed;
  height: 30px;
  border-radius: 3px;
  border: 1px;
  color: #8392B6;
  font-size: 12px;

}

.option-class-m {
  background-color: #FFFFFF;
}

.option-class-m:checked {
  background-color: #0080DC;
}

.category-container-m {
  width: 50%;
  background: #FFFFFF;
  border: 2px dashed;
  box-shadow: 0px 0px 0px 2px grey;
  height: 30px;
  border-radius: 3px;
  border: 1px;
  color: #8392B6;
  font-size: 12px;

}

.drag-m {

  color: #FFFFFF;
  font-size: 12px;
  font-weight: 500;
}

/* .drag-logo{

  

} */

.browse-m {
  color: #4286F5;
  font-weight: 350;
}

.file-class-m {
  visibility: hidden;
}

.or-class-m {
  color: #FFFFFF4D;
  font-size: 12px;
  font-weight: 500;
}

.Assist-header-m {

  align-self: flex-start;
  margin-left: 35px;
  color: #8392B6;
}

.upload-container-m {

  margin-bottom: 10px;
  margin-top: 30px;
  text-align: center;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 130px;
  border-radius: 15px;
  background: #294170;
  border: 1px solid #8392B6;

}

.drag-container-m {

  background-color: #3E5FA2;
  border-radius: 5px;
  height: 30px;
  align-items: center;
  display: flex;
  align-self: center;
  width: 40%;
  flex-direction: row;
}

.collapse-class-m {
  width: 5%;
}

.drag-m {
  font-size: 8px;
  align-content: center;
}

.browse-container-m {
  background-color: #3E5FA2;
  border-radius: 5px;
  margin-left: 20px;
  height: 30px;
  display: flex;
  align-items: center;
  width: 40%;
  font-size: 10px;
  flex-direction: row;
}

.browse-m {
  color: #FFFFFF;
}

.image-m {
  display: flex;
  margin-top: 15px;
  flex-direction: row;
}


.upload-container-m label {

  display: block;

}



.corrosion-result-m {
  margin-bottom: 10px;
  text-align: center;
  padding: 10px;
  justify-content: center;
  font-size: 15px;
  font-weight: 500;
  color: #FFFFFF;
  min-height: 20px;
  border-radius: 24px;
  background: linear-gradient(0deg, #122B45, #122B45);
  border: 2px dotted #0080DC;

}


.upload-container-m input[type='file'] {

  display: block;


}


.selectBox-m {
  position: relative;
}

.selectBox select-m {
  width: 100%;
  background: #FFFFFF;
  border: 2px dashed;
  box-shadow: 0px 0px 0px 2px grey;
  height: 30px;
  padding: 5px;
  border-radius: 3px;
  border: 1px;
  color: #8392B6;
  font-size: 12px;

}

.overSelect-m {
  position: absolute;

}

#checkBoxes-m {
  /* display: none; */
  border: 1px #8DF5E4 solid;
}

#checkBoxes-m label {
  display: block;
}

#checkBoxes-m label:hover {
  background-color: #4F615E;
}


.corrosion-detection-m {


  font-size: 24px;

  color: #FFFFFF;

  margin-bottom: 10px;

}




.industry-image-m {

  width: 100%;

  height: 300px;

  background-image: url('https://www.ibef.org/assets/images/Oil-Gas-2.jpg');
  /* Replace with your own image */

  background-size: cover;

  background-position: center;

  border: 1px solid #ccc;

  border-radius: 5px;

}




.uploaded-image-m {

  display: block;
  height: 250px;
  width: 520px;
  margin-top: 10px;
  margin-bottom: 20px;
  /* max-width: 100%; */
  background-size: cover;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-position: center;


}

.checkbox-label-m {
  /* Add styles for the checkbox label */
  display: block;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}

.show-checkboxes-m {
  /* Add styles for the "Show Categories" text */
  cursor: pointer;
  color: #007bff;
  /* Change the color as needed */
  margin-top: 10px;
}


.chat-input input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #FFFFFF;
  opacity: 1;
  /* Firefox */
}





.chat-popup-m {



  display: flex;
  flex-direction: column;
  text-align: right;

  align-items: flex-end;

  /* background-color: #007bff; */

  color: white;

  padding: 10px;

  border-radius: 5px;

  cursor: pointer;

}




.robot-icon-m {

  width: 20px;

  height: 20px;

  margin-right: 10px;

  background-image: url('https://www.ibef.org/assets/images/Oil-Gas-2.jpg');
  /* Replace with the path to your custom robot icon image */

  background-size: cover;

}




.chat-popup-text-m {



  font-size: 14px;

}




.chatbot-container-m {

  flex: 1 1;
  padding: 10px;
  display: flex;
  width: 95%;
  margin-left: 60px;
  margin-right: 30px;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #294170;
  align-self: center;

  border: 1px solid #ccc;

  border-radius: 3px;

}

.top-chat-container-m {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  border-color: #8392B6;
  height: 60px;
  border: 3px;
  text-align: left;
  background-color: #4B70B4;

}

.right-section-m {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  align-content: flex-end;
}

.popup-message-m {
  background-color: #8392B6;
  color: #ffffff;
}



.chat-messages-m {
  overflow-y: scroll;
  height: 400px;
  margin-bottom: 10px;

}

.chat-icon-m {
  width: 20%;
}


.chat-message-m {

  padding: 10px;

  margin-bottom: 5px;

  border-radius: 5px;

  font-family: 'Arial', sans-serif;

  font-size: 14px;

}

.searchWrapper {
  padding: 2px;

}



.user-m {

  background-color: #2F4B83;

  height: 35px;
  color: #FFFFFF;
  margin-right: 50px;

}




.bot-m {

  background-color: #3D61A9;
  color: #FFFFFF;
  margin-top: 15px;
  margin-left: 50px;
  min-height: 35px;
  margin-right: 15px;
  margin-bottom: 15px;

}




.chat-input-container-m {

  display: flex;
  color: #FFFFFF;

}

.send-m {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding-right: 10px;
  padding-bottom: 10px;
  align-items: center;
  align-self: flex-end;
}


.chat-input-m {

  flex: 1 1;

  margin-right: 10px;

  padding: 5px;

  font-family: 'Arial', sans-serif;
  color: #FFFFFF;
  font-size: 14px;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #494759;
  background-color: #3D61A9;

}

.chat-input-m:focus {
  border: 1px solid #494759;
}

.check-image {
  border-radius: 10px;


}

.footer-m {
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-top: auto;
}


/* Track */
::-webkit-scrollbar-m {

  width: 5px;

  height: 5px;

  scrollbar-width: thin;

}

::-webkit-scrollbar-track-m {

  background: #F9ECFF;

}


/* Handle */

::-webkit-scrollbar-thumb-m {

  background: #0080DC;

}

.img-class-m {
  width: 88%;
  height:9rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.img-class-m2 {
  width: 90%;
  height:9rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

/* Handle on hover */

::-webkit-scrollbar-thumb:hover-m {

  background: #7F00B6;

}

.icon_down_dir:before-m {
  content: "";
}


.autocomplete-container .suggestions-container ul li a {

  font: normal normal normal 14px/25px Graphik !important;

  letter-spacing: 0px;

  color: #5C5C5C !important;

  padding: 0 5px !important;

}




/* Styling for the sidebar links when collapsed */
.collapsed-sidebar .selection-m {
  text-align: center;
  /* Center the text */
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  scrollbar-width: thin;
}

::-webkit-scrollbar-track {
  background: #F9ECFF;
}

::-webkit-scrollbar-thumb {
  background: #F9ECFF;
}

::-webkit-scrollbar-thumb:hover {
  background: #F9ECFF;
}

.collapsed-sidebar .side-img1 {
  width: 50% !important;
  padding-left: 5px;
  padding-right: 5px;
}

.right-scrm-section {
  width: calc(100% - 70px) !important;
  margin-top: 4% !important;
}

.container-iframe {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  /* height: 100%; */
  margin-top: 25px;
}

.container-iframe1 {
  display: flex;
  justify-content: center;
  /* align-items: center; */
  /* height: 100%; */
  margin-top: 25px;
  margin-left: 150px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;;AAErB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;;GAOG;;AAEH;EACE,WAAW;EACX,UAAU;EACV,yDAA4C;EAC5C,sBAAsB;EACtB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;GAMG;AACH;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;;EAElB,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;;EAElB,gBAAgB;;AAElB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc;EACd,qCAAqC;AACvC;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc;EACd,gDAAgD;AAClD;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc;EACd,qCAAqC;AACvC;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,0CAA0C;AAC1C;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,kCAAkC;AACpC;;AAEA,4CAA4C;;AAE5C;EACE,aAAa;EACb,sBAAsB;;AAExB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gDAAgD;EAChD,2BAA2B;;EAE3B,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;;AAGA;;;;EAIE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;;AAE3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;;EAElB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB;6EAC2E;EAC3E,yBAAyB;;AAE3B;;;;;AAKA;;EAEE,gCAAgC;;EAEhC,eAAe;;EAEf,WAAW;;EAEX,mBAAmB;;AAErB;;;;;AAKA;;EAEE,mBAAmB;;AAErB;;;AAGA;;EAEE,cAAc;EACd,eAAe;AACjB;;;AAGA;;EAEE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;;AAEjB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;;AAE3B;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;;EAEE,cAAc;;AAEhB;;;;AAIA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mDAAmD;EACnD,0BAA0B;;AAE5B;;;AAGA;;EAEE,cAAc;;;AAGhB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;;EAGE,eAAe;;EAEf,cAAc;;EAEd,mBAAmB;;AAErB;;;;;AAKA;;EAEE,WAAW;;EAEX,aAAa;;EAEb,yEAAyE;EACzE,gCAAgC;;EAEhC,sBAAsB;;EAEtB,2BAA2B;;EAE3B,sBAAsB;;EAEtB,kBAAkB;;AAEpB;;;;;AAKA;;EAEE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;;;AAG7B;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;;;AAGA;EACE,yCAAyC;EACzC,cAAc;EACd,UAAU;EACV,YAAY;AACd;;;;;;AAMA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;;EAEjB,qBAAqB;;EAErB,+BAA+B;;EAE/B,YAAY;;EAEZ,aAAa;;EAEb,kBAAkB;;EAElB,eAAe;;AAEjB;;;;;AAKA;;EAEE,WAAW;;EAEX,YAAY;;EAEZ,kBAAkB;;EAElB,yEAAyE;EACzE,0DAA0D;;EAE1D,sBAAsB;;AAExB;;;;;AAKA;;;;EAIE,eAAe;;AAEjB;;;;;AAKA;;EAEE,SAAO;EACP,aAAa;EACb,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;;EAElB,sBAAsB;;EAEtB,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;;AAE3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;;AAIA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,UAAU;AACZ;;;AAGA;;EAEE,aAAa;;EAEb,kBAAkB;;EAElB,kBAAkB;;EAElB,gCAAgC;;EAEhC,eAAe;;AAEjB;;AAEA;EACE,YAAY;;AAEd;;;;AAIA;;EAEE,yBAAyB;;EAEzB,YAAY;EACZ,cAAc;EACd,kBAAkB;;AAEpB;;;;;AAKA;;EAEE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;;AAErB;;;;;AAKA;;EAEE,aAAa;EACb,cAAc;;AAEhB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;;AAGA;;EAEE,SAAO;;EAEP,kBAAkB;;EAElB,YAAY;;EAEZ,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;;AAE3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;;;AAGrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA,UAAU;AACV;;EAEE,UAAU;;EAEV,WAAW;;EAEX,qBAAqB;;AAEvB;;AAEA;;EAEE,mBAAmB;;AAErB;;;AAGA,WAAW;;AAEX;;EAEE,mBAAmB;;AAErB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,oBAAoB;;AAEpB;;EAEE,mBAAmB;;AAErB;;AAEA;EACE,WAAW;AACb;;;AAGA;;EAEE,uDAAuD;;EAEvD,mBAAmB;;EAEnB,yBAAyB;;EAEzB,yBAAyB;;AAE3B;;;;;AAKA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".main-m {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 20px);\n}\n.toggle-ind{\n  display: flex;\n  flex-direction: row;\n\n}\n.ind-tog{\n  color: white;\n  padding-left: 20px;\n  font-size: medium;\n}\n.left-class-m {\n  margin-left: 350px;\n  margin-bottom: 5px;\n}\n\n.left-class-m.collapsed-left-panel {\n  margin-left: 3px;\n}\n\n.industry-class-m {\n  width: 13%;\n  margin-left: 15px;\n  margin-top: 5px;\n}\n\n.sidebar-toggle {\n  width: 20px;\n  margin-bottom: 65px;\n  margin-left: 3px;\n}\n\n/* .industry-nav{\n  font-size: 14px;\n  font-family: Graphik;\n  font-weight: 400;\n  display: flex;\n  color: white;\n  padding-right: 10px;\n} */\n\n.primary {\n  width: 100%;\n  height: 7%;\n  background-image: url('./images/Header.svg');\n  background-size: cover;\n  display: flex;\n  /* background-position: center; */\n}\n\n.accentureHeader {\n  width: 6%;\n  margin-left: 10px;\n  margin-bottom: 7px;\n}\n\n.genaiHeader {\n  color: #FFFFFF;\n  font-size: 18px;\n  font-family: Graphik;\n  font-weight: 450;\n  margin: 5px 15px;\n  border-left: 1px solid #FFFFFF;\n  padding: 0px 15px;\n  width: 20%;\n}\n\n.icon-Header {\n  width: 25px;\n  height: 20px;\n  margin-bottom: 2px;\n}\n\n.icon-Header-notification{\n  width: 23px;\n  height: 17px;\n  margin-bottom: 4px;\n  margin-left: 1px;\n}\n.icon-Header-logout{\n  width: 19px;\n  height: 16px;\n  margin-bottom: 4px;\n  margin-left: 5px;\n}\n.icon-Header-circle {\n  background-color: #FFFFFF;\n  border-radius: 50%;\n  border: none;\n  height: 25px;\n  width: 25px;\n  margin-right: 10px;\n}\n\n/* .username-container {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 150px; \n  -webkit-text-overflow: ellipsis;\n} */\n.header-toast {\n  color: black;\n  font-size: 12px;\n  font-family: Graphik;\n  font-weight: 355;\n}\n\n.header-icon {\n  display: flex;\n  transform: translate(81%, 20%);\n  top: 10%;\n  left: 90%;\n}\n\n.header-dropdown-icon {\n  width: 15px;\n  margin:2px;\n}\n.user-header-box{\n  background-color: #FFFFFF;\n  border-radius: 30px;\n  border: none;\n  height: fit-content;\n  /* width: fit-content; */\n  /* margin-right: 10px; */\n  padding: 2px 5px;\n  display: flex;\n  font-size: 12px;\n  font-weight: 430;\n  font-family: Graphik;\n}\n.indutry-m {\n  color: #ffffff;\n  font-size: 20px;\n  display: flex;\n  flex-direction: row;\n  margin-top: 20px;\n  font-weight: 10px;\n\n}\n\n.industry-container-m {\n  display: none;\n  position: absolute;\n  background-color: #ffffff;\n  border: 1px solid #ccc;\n  padding: 10px;\n}\n\n.selection:hover+.industry-container-m {\n  display: block;\n}\n\n.selection-m {\n  color: #738395;\n  padding-bottom: 5px;\n  margin-bottom: 10px;\n  border-left: none;\n  border-right: none;\n  margin-bottom: 20px;\n  width: 80%;\n  font-size: 15px;\n  margin-top: 80px;\n  font-weight: 7px;\n}\n\n.icon-industry {\n  margin-right: 10px;\n  width: 50%;\n}\n\n.icon {\n  margin-right: 30px;\n\n  margin-top: 10px;\n\n}\n\n.icon1 {\n  margin-right: 30px;\n\n  margin-top: 10px;\n\n}\n\n.icon-container-m:hover {\n  border-bottom: 5px solid #AD8BFF;\n  border-left: 2px solid #738395;\n  border-right: 2px solid #738395;\n  border-top: 2px solid #738395;\n  color: #A404ED;\n  /* Add other hover styles as needed */\n}\n\n.icon-container-m:active {\n\n  border-bottom: 5px solid #AD8BFF;\n  border-left: 2px solid #738395;\n  border-right: 2px solid #738395;\n  border-top: 2px solid #738395;\n  color: #A404ED;\n  /* Add other active (clicked) styles as needed */\n}\n\n.icon-container1-m:hover {\n\n  border-bottom: 5px solid #AD8BFF;\n  border-left: 2px solid #738395;\n  border-right: 2px solid #738395;\n  border-top: 2px solid #738395;\n  color: #A404ED;\n  /* Add other hover styles as needed */\n}\n\n.icon-container1-m:active {\n\n  border-bottom: 5px solid #AD8BFF;\n  border-left: 2px solid #738395;\n  border-right: 2px solid #738395;\n  border-top: 2px solid #738395;\n  color: #A404ED;\n  /* Add other active (clicked) styles as needed */\n}\n\n.col-sm-8 icons2-m {\n  margin-top: 50px;\n}\n\n\n/* Decrease the icon size when collapsed */\n.collapsed-sidebar .side-img {\n  width: 25px !important;\n}\n\n.collapsed-sidebar .side-img1 {\n  width: 25px !important;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.expanded-sidebar .side-img2{\n  width: 10px !important;\n  margin-right: 20px;\n  margin-left: 5px;\n}\n.collapsed-sidebar .side-img2{\n  width: 25px !important;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n\n.icon-container-m {\n  color: #fff;\n  text-decoration: none;\n  margin-top: 20px;\n  background-color: rgba(59, 65, 102, 1);\n  /* Black with 10% opacity */\n  height: 210px;\n  text-align: center;\n  padding-top: 10px;\n  border-radius: 15px;\n  width: 20%;\n  margin-bottom: 10px;\n  margin-left: 30px;\n}\n\n.icon-container-m2 {\n  color: #fff;\n  text-decoration: none;\n  margin-top: 20px;\n  background-color: rgba(59, 65, 102, 1);\n  /* Black with 10% opacity */\n  height: 210px;\n  text-align: center;\n  padding-top: 10px;\n  border-radius: 15px;\n  width: 21%;\n  margin-bottom: 10px;\n  margin-left: 30px;\n}\n\n.mark {\n  background-color: #fff;\n}\n\n.watermark-m {\n  padding-top: 50px;\n}\n\n.landing-text {\n  font-size: 15px;\n  font-family: Graphik;\n  font-weight: 400;\n  color: #fff;\n  margin-top: 5px;\n  text-align: left;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.landing-text-drill {\n  font-size: 15px;\n  font-family: Graphik;\n  font-weight: 400;\n  color: #fff;\n  margin-top: 5px;\n  text-wrap: wrap;\n  width: 180px;\n  margin-left: 10px;\n  margin-right: 10px;\n  text-align: left;\n}\n\n.icon-container1-m {\n  margin-top: 10px;\n  color: #fff;\n  text-decoration: none;\n  background-color: rgba(59, 65, 102, 1);\n  /* Black with 10% opacity */\n  height: 213px;\n  padding-top: 10px;\n  border-radius: 15px;\n  text-align: center;\n  width: 20%;\n  margin-bottom: 20px;\n  margin-left: 30px;\n}\n\n.utility-header-m {\n  font-size: 20px;\n  font-weight: 10px;\n  color: #000;\n  margin-left: 30px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n/* Add this to your App.css or a separate CSS file */\n.left-panel-m.collapsed-left-panel {\n  /* Define your new styles here */\n  /* For example: */\n  width: 70px;\n  transition: width 0.3s ease-in-out;\n}\n\n/* You can adjust the properties as needed */\n\n.energy-m {\n  display: flex;\n  flex-direction: column;\n\n}\n\n.sub-H {\n  display: flex;\n  flex-direction: row;\n}\n\n.head {\n  color: #738395;\n  padding-left: 30px;\n  padding-top: 20px;\n  padding-bottom: 15px;\n  font-size: 15px;\n}\n\n.head1 {\n  color: #fff;\n  margin-left: 30px;\n  padding-top: 20px;\n  padding-bottom: 15px;\n  border-bottom: 3px solid #AD8BFF;\n  font-size: 15px;\n}\n\n.icons-m {\n  display: flex;\n  flex-direction: row;\n}\n\n.left-panel-m {\n\n  align-items: start;\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  /* White with 10% opacity */\n\n  display: flex;\n  flex-direction: column;\n  padding-top: 80px;\n  padding-left: 20px;\n  height: calc(100vh - 20px);\n  width: 190px;\n}\n\n.collapsed-sidebar.left-panel-m {\n  widows: 5%;\n}\n\n.utility-m {\n  color: red;\n  font-size: 20px;\n}\n\n.middle-panel-m {\n  display: flex;\n  flex-direction: row;\n  /* height: 70px; */\n}\n\n.logo-header-m {\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.Heading-m {\n  color: #FFFFFF;\n  text-align: left;\n  font-size: 20px;\n}\n\n.admin-img-m {\n  width: 90%;\n}\n\n.industry-links {\n  padding: 10px 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n  max-height: 500px;\n  /* A default value when not collapsed */\n}\n\n.industry-links.collapsed {\n  max-height: 0;\n}\n\n.side-img {\n  margin-right: 20px;\n  width: 15%;\n}\n\n.admin-text-m {\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 14px;\n  color: #982588;\n}\n\n.no-underline {\n  text-decoration: none;\n}\n\n.selected-m {\n  color: #AD8BFF;\n  padding-bottom: 5px;\n  background-color: rgba(59, 65, 102, 1);\n  padding-right: 50px;\n  margin-bottom: 40px;\n  width: 90%;\n  font-size: 15px;\n  font-weight: 7px;\n  border-left: 3px solid #AD8BFF;\n}\n\n.collapsed-sidebar.selected-m {\n  padding-right: 5px;\n}\n\n.collapse-img-m {\n  justify-content: end;\n  padding-right: 10px;\n  align-items: center;\n  align-self: flex-end;\n}\n\n.home-image-m {\n  margin-bottom: 5px;\n  margin-top: 5px;\n  width: 15%;\n  margin-right: 10px;\n}\n\n.Admin-m {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  padding-right: 10px;\n  align-items: center;\n  margin-left: 1200px;\n  align-self: flex-end;\n}\n\n\n.second-container-m {\n\n\n\n  margin-top: 20px;\n  display: flex;\n  flex-direction: row;\n  border-radius: 10px;\n  border-color: #8392B6;\n  margin-left: 30px;\n  min-height: 540px;\n  border: 3px;\n  padding: 20px;\n  margin-right: 15px;\n  text-align: left;\n  background-color: #25304C;\n\n}\n\n.left-section-m {\n  display: flex;\n  padding-right: 20px;\n  border-right: 1px solid #8392B6;\n  flex-direction: column;\n}\n\n.select-dropdown-m {\n  color: #8392B6;\n  display: flex;\n  flex-direction: row;\n  font-size: 10px;\n  padding-top: 20px;\n}\n\n.button-m {\n  color: #4286F5;\n  font-size: 10px;\n  width: 40%;\n  border-radius: 10px;\n  margin-left: 75px;\n  justify-content: center;\n  box-shadow: 20px #122B45;\n  margin-top: 30px;\n  background-color: #FFFFFF;\n  height: 30px;\n}\n\n.loading-m {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  color: black;\n  margin-top: 10px;\n}\n\n\n.loading::after-m {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid white;\n  border-top-color: transparent;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.assistant-heading-m {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  margin-left: 5px;\n  color: white;\n  text-align: center;\n\n}\n\n.sales {\n  background-color: red;\n}\n\n.panels-m {\n  display: flex;\n  background-color: rgba(32, 35, 66, 1);\n  flex-direction: row;\n  min-height: calc(100vh - 20px);\n}\n\n.right-panel-m {\n\n  position: relative;\n\n  background-color: #142137;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  background: linear-gradient(0deg, #002644, #002644),\n    linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2));\n  border: 1px solid #335169;\n\n}\n\n\n\n\n.title-m {\n\n  font-family: 'Arial', sans-serif;\n\n  font-size: 28px;\n\n  color: #333;\n\n  margin-bottom: 20px;\n\n}\n\n\n\n\n.dropdown-container-m {\n\n  margin-bottom: 20px;\n\n}\n\n\n.dropdown-label-m {\n\n  color: #BEC1D6;\n  font-size: 12px;\n}\n\n\n.logo-class-m {\n\n  width: 80%;\n  margin-left: 20px;\n}\n\n.selected-files-container-m {\n  margin-top: 10px;\n  min-height: 50px;\n}\n\n/* CSS for selected files */\n.selected-file-m {\n  margin-top: 5px;\n  padding: 5px;\n  color: #FFFFFF;\n  font-size: 10px;\n}\n\n.dropdown-select-m {\n\n  background: #FFFFFF;\n  appearance: none;\n  border: 2px dashed;\n  height: 30px;\n  border-radius: 3px;\n  border: 1px;\n  color: #8392B6;\n  font-size: 12px;\n\n}\n\n.option-class-m {\n  background-color: #FFFFFF;\n}\n\n.option-class-m:checked {\n  background-color: #0080DC;\n}\n\n.category-container-m {\n  width: 50%;\n  background: #FFFFFF;\n  border: 2px dashed;\n  box-shadow: 0px 0px 0px 2px grey;\n  height: 30px;\n  border-radius: 3px;\n  border: 1px;\n  color: #8392B6;\n  font-size: 12px;\n\n}\n\n.drag-m {\n\n  color: #FFFFFF;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* .drag-logo{\n\n  \n\n} */\n\n.browse-m {\n  color: #4286F5;\n  font-weight: 350;\n}\n\n.file-class-m {\n  visibility: hidden;\n}\n\n.or-class-m {\n  color: #FFFFFF4D;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.Assist-header-m {\n\n  align-self: flex-start;\n  margin-left: 35px;\n  color: #8392B6;\n}\n\n.upload-container-m {\n\n  margin-bottom: 10px;\n  margin-top: 30px;\n  text-align: center;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 130px;\n  border-radius: 15px;\n  background: #294170;\n  border: 1px solid #8392B6;\n\n}\n\n.drag-container-m {\n\n  background-color: #3E5FA2;\n  border-radius: 5px;\n  height: 30px;\n  align-items: center;\n  display: flex;\n  align-self: center;\n  width: 40%;\n  flex-direction: row;\n}\n\n.collapse-class-m {\n  width: 5%;\n}\n\n.drag-m {\n  font-size: 8px;\n  align-content: center;\n}\n\n.browse-container-m {\n  background-color: #3E5FA2;\n  border-radius: 5px;\n  margin-left: 20px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  width: 40%;\n  font-size: 10px;\n  flex-direction: row;\n}\n\n.browse-m {\n  color: #FFFFFF;\n}\n\n.image-m {\n  display: flex;\n  margin-top: 15px;\n  flex-direction: row;\n}\n\n\n.upload-container-m label {\n\n  display: block;\n\n}\n\n\n\n.corrosion-result-m {\n  margin-bottom: 10px;\n  text-align: center;\n  padding: 10px;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 500;\n  color: #FFFFFF;\n  min-height: 20px;\n  border-radius: 24px;\n  background: linear-gradient(0deg, #122B45, #122B45);\n  border: 2px dotted #0080DC;\n\n}\n\n\n.upload-container-m input[type='file'] {\n\n  display: block;\n\n\n}\n\n\n.selectBox-m {\n  position: relative;\n}\n\n.selectBox select-m {\n  width: 100%;\n  background: #FFFFFF;\n  border: 2px dashed;\n  box-shadow: 0px 0px 0px 2px grey;\n  height: 30px;\n  padding: 5px;\n  border-radius: 3px;\n  border: 1px;\n  color: #8392B6;\n  font-size: 12px;\n\n}\n\n.overSelect-m {\n  position: absolute;\n\n}\n\n#checkBoxes-m {\n  /* display: none; */\n  border: 1px #8DF5E4 solid;\n}\n\n#checkBoxes-m label {\n  display: block;\n}\n\n#checkBoxes-m label:hover {\n  background-color: #4F615E;\n}\n\n\n.corrosion-detection-m {\n\n\n  font-size: 24px;\n\n  color: #FFFFFF;\n\n  margin-bottom: 10px;\n\n}\n\n\n\n\n.industry-image-m {\n\n  width: 100%;\n\n  height: 300px;\n\n  background-image: url('https://www.ibef.org/assets/images/Oil-Gas-2.jpg');\n  /* Replace with your own image */\n\n  background-size: cover;\n\n  background-position: center;\n\n  border: 1px solid #ccc;\n\n  border-radius: 5px;\n\n}\n\n\n\n\n.uploaded-image-m {\n\n  display: block;\n  height: 250px;\n  width: 520px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  /* max-width: 100%; */\n  background-size: cover;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background-position: center;\n\n\n}\n\n.checkbox-label-m {\n  /* Add styles for the checkbox label */\n  display: block;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 5px;\n}\n\n.show-checkboxes-m {\n  /* Add styles for the \"Show Categories\" text */\n  cursor: pointer;\n  color: #007bff;\n  /* Change the color as needed */\n  margin-top: 10px;\n}\n\n\n.chat-input input::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #FFFFFF;\n  opacity: 1;\n  /* Firefox */\n}\n\n\n\n\n\n.chat-popup-m {\n\n\n\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n\n  align-items: flex-end;\n\n  /* background-color: #007bff; */\n\n  color: white;\n\n  padding: 10px;\n\n  border-radius: 5px;\n\n  cursor: pointer;\n\n}\n\n\n\n\n.robot-icon-m {\n\n  width: 20px;\n\n  height: 20px;\n\n  margin-right: 10px;\n\n  background-image: url('https://www.ibef.org/assets/images/Oil-Gas-2.jpg');\n  /* Replace with the path to your custom robot icon image */\n\n  background-size: cover;\n\n}\n\n\n\n\n.chat-popup-text-m {\n\n\n\n  font-size: 14px;\n\n}\n\n\n\n\n.chatbot-container-m {\n\n  flex: 1;\n  padding: 10px;\n  display: flex;\n  width: 95%;\n  margin-left: 60px;\n  margin-right: 30px;\n  flex-direction: column;\n  justify-content: flex-end;\n  background-color: #294170;\n  align-self: center;\n\n  border: 1px solid #ccc;\n\n  border-radius: 3px;\n\n}\n\n.top-chat-container-m {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: row;\n  border-radius: 5px;\n  border-color: #8392B6;\n  height: 60px;\n  border: 3px;\n  text-align: left;\n  background-color: #4B70B4;\n\n}\n\n.right-section-m {\n  align-items: flex-end;\n  display: flex;\n  flex-direction: column;\n  align-content: flex-end;\n}\n\n.popup-message-m {\n  background-color: #8392B6;\n  color: #ffffff;\n}\n\n\n\n.chat-messages-m {\n  overflow-y: scroll;\n  height: 400px;\n  margin-bottom: 10px;\n\n}\n\n.chat-icon-m {\n  width: 20%;\n}\n\n\n.chat-message-m {\n\n  padding: 10px;\n\n  margin-bottom: 5px;\n\n  border-radius: 5px;\n\n  font-family: 'Arial', sans-serif;\n\n  font-size: 14px;\n\n}\n\n.searchWrapper {\n  padding: 2px;\n\n}\n\n\n\n.user-m {\n\n  background-color: #2F4B83;\n\n  height: 35px;\n  color: #FFFFFF;\n  margin-right: 50px;\n\n}\n\n\n\n\n.bot-m {\n\n  background-color: #3D61A9;\n  color: #FFFFFF;\n  margin-top: 15px;\n  margin-left: 50px;\n  min-height: 35px;\n  margin-right: 15px;\n  margin-bottom: 15px;\n\n}\n\n\n\n\n.chat-input-container-m {\n\n  display: flex;\n  color: #FFFFFF;\n\n}\n\n.send-m {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  padding-right: 10px;\n  padding-bottom: 10px;\n  align-items: center;\n  align-self: flex-end;\n}\n\n\n.chat-input-m {\n\n  flex: 1;\n\n  margin-right: 10px;\n\n  padding: 5px;\n\n  font-family: 'Arial', sans-serif;\n  color: #FFFFFF;\n  font-size: 14px;\n  height: 50px;\n  border-radius: 10px;\n  border: 1px solid #494759;\n  background-color: #3D61A9;\n\n}\n\n.chat-input-m:focus {\n  border: 1px solid #494759;\n}\n\n.check-image {\n  border-radius: 10px;\n\n\n}\n\n.footer-m {\n  font-family: 'Arial', sans-serif;\n  font-size: 14px;\n  color: #666;\n  text-align: center;\n  margin-top: auto;\n}\n\n\n/* Track */\n::-webkit-scrollbar-m {\n\n  width: 5px;\n\n  height: 5px;\n\n  scrollbar-width: thin;\n\n}\n\n::-webkit-scrollbar-track-m {\n\n  background: #F9ECFF;\n\n}\n\n\n/* Handle */\n\n::-webkit-scrollbar-thumb-m {\n\n  background: #0080DC;\n\n}\n\n.img-class-m {\n  width: 88%;\n  height:9rem;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.img-class-m2 {\n  width: 90%;\n  height:9rem;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n/* Handle on hover */\n\n::-webkit-scrollbar-thumb:hover-m {\n\n  background: #7F00B6;\n\n}\n\n.icon_down_dir:before-m {\n  content: \"\";\n}\n\n\n.autocomplete-container .suggestions-container ul li a {\n\n  font: normal normal normal 14px/25px Graphik !important;\n\n  letter-spacing: 0px;\n\n  color: #5C5C5C !important;\n\n  padding: 0 5px !important;\n\n}\n\n\n\n\n/* Styling for the sidebar links when collapsed */\n.collapsed-sidebar .selection-m {\n  text-align: center;\n  /* Center the text */\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n  scrollbar-width: thin;\n}\n\n::-webkit-scrollbar-track {\n  background: #F9ECFF;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #F9ECFF;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #F9ECFF;\n}\n\n.collapsed-sidebar .side-img1 {\n  width: 50% !important;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.right-scrm-section {\n  width: calc(100% - 70px) !important;\n  margin-top: 4% !important;\n}\n\n.container-iframe {\n  display: flex;\n  justify-content: center;\n  /* align-items: center; */\n  /* height: 100%; */\n  margin-top: 25px;\n}\n\n.container-iframe1 {\n  display: flex;\n  justify-content: center;\n  /* align-items: center; */\n  /* height: 100%; */\n  margin-top: 25px;\n  margin-left: 150px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
